import dynamic from 'next/dynamic'
import liveStyle from '../../styles/components/live.js'

const VideoPlayer = dynamic(() => import('../VideoPlayer/VideoPlayer'), { ssr: false })

const LivePage = ({ title, src, type, captions, thumbnail }) => (
  <>
    <VideoPlayer
      video={{
        src,
        type,
        isLive: true,
        captions,
        poster: thumbnail
      }}
      title={title}
    />
    {captions && <em>{captions}</em>}

    <style jsx global>
      {liveStyle}
    </style>
  </>
)

export default LivePage
